export default {
  SET_PARAMETROS (state, value) {
    state.parametros = value
  }
}
